/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { createAction } from '../../utils/redux-utils';
import { CompaniesListDto, CompaniesListFilterParams } from '../api/companies/companiesClient.typings';
import { SortQueryParams } from '../api/apiCommon.typings';
import { Notification, NOTIFICATION_TYPES } from '../../utils/utils';
import { i18n } from '../translation/i18n';

export enum CompaniesActionType {
    OPEN_REGISTRY_COMPANIES_LIST_PAGE = 'RegistryCompaniesList/ open page',
    EXIT_REGISTRY_COMPANIES_LIST_PAGE = 'RegistryCompaniesList/ exit page',

    FETCH_NEXT_PAGE_START = 'RegistryCompaniesList/ fetch next page',
    APPLY_FILTERS = 'RegistryCompaniesList/ apply filters',
    APPLY_SORTING = 'RegistryCompaniesList/ apply sorting',

    CHANGE_FILTERS = 'RegistryCompaniesList/ change filters',

    DOWNLOAD_EXCEL = 'RegistryCompaniesList/ download companies list as excel',
    DOWNLOAD_EXCEL_SUCCESS = 'RegistryCompaniesList/ download companies list as excel success',
    DOWNLOAD_EXCEL_ERROR = 'RegistryCompaniesList/ download companies list as excel error',

    FETCH_COMPANIES_LIST_SUCCESS = 'RegistryCompaniesList/ fetch companies list success',
    FETCH_COMPANIES_LIST_ERROR = 'RegistryCompaniesList/ fetch companies list error',
}

export const openRegistryCompaniesListAction = () =>
    createAction(CompaniesActionType.OPEN_REGISTRY_COMPANIES_LIST_PAGE);

export const exitRegistryCompaniesListAction = () =>
    createAction(CompaniesActionType.EXIT_REGISTRY_COMPANIES_LIST_PAGE);

export const fetchNextPageStartAction = () => createAction(CompaniesActionType.FETCH_NEXT_PAGE_START);

export const applyFilteringAction = () => createAction(CompaniesActionType.APPLY_FILTERS);

export const applySortingAction = (params: SortQueryParams) => createAction(CompaniesActionType.APPLY_SORTING, params);

export const changeFiltersAction = (params: CompaniesListFilterParams) =>
    createAction(CompaniesActionType.CHANGE_FILTERS, params);

export const downloadCompaniesListAsExcelAction = () => createAction(CompaniesActionType.DOWNLOAD_EXCEL);

export const downloadCompaniesListAsExcelSuccessAction = () =>
    createAction(CompaniesActionType.DOWNLOAD_EXCEL_SUCCESS, {
        notification: {
            type: NOTIFICATION_TYPES[1],
            message: i18n.t('downloadings.fileCreationRequestAccepted'),
        },
    });

export const downloadCompaniesListAsExcelErrorAction = (notification: Notification) =>
    createAction(CompaniesActionType.DOWNLOAD_EXCEL_ERROR, { notification });

export const fetchCompaniesListSuccessAction = (list: CompaniesListDto) =>
    createAction(CompaniesActionType.FETCH_COMPANIES_LIST_SUCCESS, {
        list,
        notification:
            list.companies.length === 0
                ? {
                      type: NOTIFICATION_TYPES[1],
                      message: i18n.t('errors.notFoundByParams'),
                  }
                : null,
    });

export const fetchCompaniesListErrorAction = (notification: Notification) =>
    createAction(CompaniesActionType.FETCH_COMPANIES_LIST_ERROR, { notification });

export type CompaniesAction =
    | ReturnType<typeof openRegistryCompaniesListAction>
    | ReturnType<typeof exitRegistryCompaniesListAction>
    | ReturnType<typeof fetchNextPageStartAction>
    | ReturnType<typeof applyFilteringAction>
    | ReturnType<typeof applySortingAction>
    | ReturnType<typeof changeFiltersAction>
    | ReturnType<typeof downloadCompaniesListAsExcelAction>
    | ReturnType<typeof downloadCompaniesListAsExcelSuccessAction>
    | ReturnType<typeof downloadCompaniesListAsExcelErrorAction>
    | ReturnType<typeof fetchCompaniesListSuccessAction>
    | ReturnType<typeof fetchCompaniesListErrorAction>;
